// Site configuration
export const SITE_ID = '311ba6a4-f32f-417e-8833-6d04dc3c0d5d'; // Zesha Coffee - Supabase siteler tablosundan

/** Türkiye saatini (UTC+3) DB'ye uyumlu ISO string olarak döndürür */
export function nowTR(): string {
  const now = new Date();
  // UTC+3 offset ekle
  const trOffset = 3 * 60 * 60 * 1000;
  const trDate = new Date(now.getTime() + trOffset);
  // "2024-01-15T14:30:00" formatında döndür (timezone suffix olmadan, DB timestamp without tz için)
  return trDate.toISOString().replace('Z', '').slice(0, 19);
}

export const LOGO_URL = 'https://static.readdy.ai/image/9bc2349a8039d11e997391420dde935f/075f0886dd1f7b0625a50d721d43f74a.png';

export const SITE_NAME = 'Zesha Coffee';

export const CURRENCY_SYMBOL = '₺';

export const FREE_SHIPPING_THRESHOLD = 500;

export const SUPABASE_URL = 'https://ulfrtxtrrplygzdbdoab.supabase.co';
